import React, { useState, useEffect, useLayoutEffect } from "react";

import interact from "interactjs";
import downloadFile from "../../../shared/functions/downloadFile";
import backendCfg from "../../../../config/backend";

import { FaExpandArrowsAlt } from "react-icons/fa";

import { Menu, Dropdown, Divider, Button, Modal, Form, Alert } from "antd";
import {
  MenuOutlined,
  AppstoreOutlined,
  CheckOutlined,
  FullscreenOutlined,
  EditOutlined,
  ShareAltOutlined,
  CameraOutlined
} from "@ant-design/icons";

import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { asyncTimeout } from "../../../shared/functions/timeout";

import { useTranslation } from "react-i18next";
import { useGlobalStore } from "../../../../stores/globalBackendStore";

import TemplatePreview from "../../../shared/components/TemplatePreview/Index";
import TemplateEditForm from "./TemplateEditForm";
import TemplateFormatSelector from "./TemplateFormatSelector";
import ImageEditorModal from "../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";


import {
  getElementsToInit,
  initInteract,
  resetMoveResize,
  unmountInteract,
} from "../../../shared/functions/wysiwyg";

import _, { initial } from "lodash";
import frontend from "../../../../config/frontend";

const { SubMenu } = Menu;

export const fcbTemplates = [
  'fcb_lineup',
  'fcb_results',
  'fcb_heatmap',
  'fcb_goal',
  'fcb_image_table',
  'fcb_matchday_slider_1',
  'fcb_matchday_slider_2',
  'fcb_matchday_slider_3',
  'fcb_matchday_slider_4'
]

export const fcbResizeTemplates = [
  'fcb_results',
  'fcb_heatmap',
  'fcb_goal',
  'fcb_image_table',
  'fcb_matchday_slider_1',
  'fcb_matchday_slider_2',
  'fcb_matchday_slider_3',
  'fcb_matchday_slider_4'
]

const TemplateEditPopup = (props) => {
  const { t } = useTranslation();
  const {
    visible,
    setVisible,
    template,
    initialTemplateData,
    setReloadTemplatesList,
    isNew,
    setCurrentTemplate,
    setShowEdit
  } = props;
  const [form] = Form.useForm();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [btnEditLoading, setBtnEditLoading] = useState(false);
  const selectedMatchday = useGlobalStore((state) => state.selectedMatchday);

  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const templateSetup = _.find(apiSetup.templates, {
    name: template.template_name,
  });
  const availableFormats = _.get(templateSetup, "formats", []);
  const client = frontend.client;
  const isFcb = client === "fcb_live" && (fcbTemplates?.includes(templateSetup?.name));
  const isFcbView = (templateSetup?.name?.includes('fcb_'));

  const [currentTemplateData, setCurrentTemplateData] =
    useState(initialTemplateData);
  const [newStylingData, setNewStylingData] = useState({});
  const [editFormResponseData, setEditFormResponseData] = useState({});
  const [animation, setAnimation] = useState(false);
  const [mode, setMode] = useState("animation");
  const [previewReady, setPreviewReady] = useState(false);
  const [extraEventsInit, setExtraEventsInit] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // need to get current previewFormat
  let _currentFormat = initialTemplateData?.currentFormat || availableFormats[0];
  const [previewFormat, setPreviewFormat] = useState(_currentFormat);

  const fullScreenHandle = useFullScreenHandle();

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = async () => {
    setButtonLoading(true);
    form.submit();
  };

  const handleEdit = async () => {
    setBtnEditLoading(true);
    form.submit();
  }

  const onFormFinished = (newTemplate) => {
    setButtonLoading(false);
    if (btnEditLoading) {
      setBtnEditLoading(false);
      if (newTemplate) {
        const { data } = newTemplate;
        setCurrentTemplate(data[0])
        setShowEdit(true);
      }
    }
  }

  const handleCancel = () => {
    setVisible(false);
    handleResetData();
  };

  const handleResetData = () => {
    const copy = _.cloneDeep(initialTemplateData);
    resetMoveResize({ currentTemplateData, initialTemplateData });
    setNewStylingData({});

    _.each(copy?.data?.fields, (i) => {
      _.set(i, 'styles', {})
    })

    setCurrentTemplateData(copy);
  };

  const handleRestartAnimation = (e) => {
    setAnimation(false);
    setTimeout(() => {
      setAnimation(true);
    }, 100);
  };

  const handleAnimationOn = (e) => {
    setAnimation(!animation);
  };

  useEffect(() => {
    setCurrentTemplateData(initialTemplateData);
  }, [previewFormat]);

  useEffect(() => {
    if (!_.isEmpty(editFormResponseData)) {
      setReloadTemplatesList({
        ...editFormResponseData,
        reload: true,
      });
    }
  }, [editFormResponseData]);

  // WYSIWYG EXTRA ACTIONS
  useLayoutEffect(() => {
    if (visible) {
      setTimeout(() => {
        // if (!extraEventsInit) {
        //     initMoveResize({currentTemplateData, newStylingData, setNewStylingData, previewFormat});
        //     setExtraEventsInit(true);
        // }
        // setAnimation(true);
        setPreviewReady(true);
        // To prevent draggable in preview mode in fcb templates
        if (!currentTemplateData?.template_name?.includes('fcb_')) {
          initInteract(
            currentTemplateData,
            newStylingData,
            setNewStylingData,
            previewFormat,
          );
        }

      }, 500);
    } else {
      unmountInteract(currentTemplateData);
      setPreviewReady(false);
      setAnimation(false);
    }

    return () => {
      setPreviewReady(false);
      setAnimation(false);
      unmountInteract(currentTemplateData);
      // handleResetData();
      // setCurrentTemplateData(null);
    };
  }, [visible]);

  useEffect(() => {
    if (visible) {
      const fields = _.get(currentTemplateData, "data.fields");
      const initialStylingData = {};
      fields.forEach((item, index) => {
        if (item.dragResize || item.drag) {
          if (!_.isEmpty(item.styles)) {
            const stylesFormat = _.get(item, `styles`, null);

            if (stylesFormat) {
              _.set(initialStylingData, `${item.id}`, item.styles);
            }
          }
        }
      });

      setNewStylingData(initialStylingData);

      if (previewFormat) {
        // To prevent draggable in preview mode in fcb templates
        if (!currentTemplateData?.template_name?.includes('fcb_')) {
          initInteract(
            currentTemplateData,
            newStylingData,
            setNewStylingData,
            previewFormat,
          );
        }
      }
    }

    return () => {
      unmountInteract(currentTemplateData);
    };
  }, [previewFormat, visible]);

  const onClick = async (menuItem, actionType, data) => {
    const { template, format } = data;
    const downloadURL = `${backendCfg.screenshotsUrl
      .replace("[[TEMPLATE]]", template.template_name)
      .replace("[[TYPE]]", `download_${format}`)
      .replace(
        "[[UUID]]",
        template.uuid,
      )}?action=download&filename=${template.name}.jpg`;
    downloadFile(downloadURL);
  };

  // 2) Create the download menu
  const downloadMenu = (
    <Menu>
      {availableFormats.map((format) => (
        <Menu.Item
          key={"download_screenshot_" + format}
          onClick={(menuInfo) => {
            onClick(menuInfo, "download_screenshot", {
              format: format,
              template,
            });
          }}
        >
          {format}
        </Menu.Item>
      ))}
    </Menu>
  );

  // const liveCreation = _.get(templateSetup, "liveCreation", false);
  const hasDraftData = template?.uuid == 0;
  const liveCreation = false;
  const template_name = currentTemplateData?.template_name;
  // const isStaticSlide = template_name === "staticslide";
  const isStaticSlide = false;

  let previewSrc = `/images/preview/opta/${template.template_name}_${previewFormat}.jpg`;


  return (
    visible && (
      <>
        <Modal
          className={
            isFcb ? "comp-TemplateEditPopupFCB" : "comp-TemplateEditPopup"
          }
          title={null}
          open={visible}
          okButtonProps={{ disabled: liveCreation }}
          destroyOnClose={true}
          maskClosable={false}
          confirmLoading={buttonLoading}
          onCancel={handleCancel}
          width={isStaticSlide ? "1536px" : isFcb ? "820px" : "1350px"}
          bodyStyle={{ height: isFcb ? 820 : 820, paddingBottom: 0 }}
          style={{ top: 5, left: 5, maxWidth: 1536 }}
          footer={
            (isNew && !isFcb)
              ? [
                <Button key="cancel" onClick={handleCancel}>
                  {t("Cancel")}
                </Button>,
                <Button
                  key="ok"
                  type="primary"
                  loading={buttonLoading}
                  onClick={handleOk}
                  disabled={liveCreation}
                >
                  {t("Save")}
                </Button>,
                <Button
                  key="ok"
                  type="primary"
                  loading={btnEditLoading}
                  onClick={handleEdit}
                  disabled={liveCreation}
                >
                  {/* {t("Save/Edit")} */}
                  {t("Edit")}
                </Button>
                ,
              ]
              : null // no footer when !isNew
          }
        >
          {/* Show buttons only if isNew is false */}
          <div className={"edit-container"}>
            <div className={"preview-side"}>
              <FullScreen handle={fullScreenHandle}>
                <div className={"preview-header"}>
                  <div className={"preview-header-btns"}>
                    <TemplateFormatSelector
                      template={currentTemplateData}
                      previewFormat={previewFormat}
                      setPreviewFormat={setPreviewFormat}
                    />
                    <Divider type="vertical" />
                    {
                      !isFcb &&
                      <Button type="primary" onClick={handleRestartAnimation}>
                        Restart animation
                      </Button>
                    }

                    {
                      !isFcb && !isFcbView &&
                      <>
                        <Divider type="vertical" />
                        <Button type="primary" onClick={handleResetData}>
                          Reset data
                        </Button>
                      </>
                    }
                    {
                      !isFcb && !isFcbView &&
                      <>
                        <Divider type="vertical" />
                        <Button type="primary" onClick={handleAnimationOn}>
                          Animation {animation ? "Off" : "On"}
                        </Button>
                      </>
                    }
                    {
                      !isNew && !isFcb &&
                      <>
                        <Divider type="vertical" />
                        <Button
                          key="ok"
                          type="primary"
                          loading={buttonLoading}
                          onClick={handleOk}
                          disabled={liveCreation}
                        >
                          {t("Save")}
                        </Button>
                      </>
                    }

                    {
                      isNew && isFcb && (
                        [
                          <Divider type="vertical" />,
                          <Button
                            key="ok"
                            type="primary"
                            loading={buttonLoading}
                            onClick={handleOk}
                            disabled={liveCreation}
                          >
                            {t("Save")}
                          </Button>,
                          <Divider type="vertical" />,
                          <Button
                            key="ok"
                            type="primary"
                            loading={btnEditLoading}
                            onClick={handleEdit}
                            disabled={liveCreation}
                          >
                            {/* {t("Save/Edit")} */}
                            {t("Edit")}
                          </Button>
                          ,
                        ]
                      )
                    }
                    {!isNew && isFcb && (
                      <>
                        <Divider type="vertical" />
                        <Button
                          type="primary"
                          onClick={() => setShowEditModal(true)}
                        >
                          <EditOutlined /> Edit
                        </Button>
                        <Divider type="vertical" />
                        {/* <Button type="primary">
                          <ShareAltOutlined /> Share
                        </Button>
                        <Divider type="vertical" /> */}
                        {
                          isFcb ? <>
                            <Button type="primary"
                              onClick={() => {
                                onClick(null, "download_screenshot", {
                                  format: initialTemplateData?.currentFormat, // current format
                                  template,
                                });
                              }}
                            >
                              {/* <Dropdown overlay={downloadMenu} trigger={["click"]}> */}
                              {/* <span> */}
                              <CameraOutlined /> Download
                              {/* </span> */}
                              {/* </Dropdown> */}
                            </Button>
                            <Divider type="vertical" />
                          </> : <>
                            <Button type="primary"
                            >
                              <Dropdown overlay={downloadMenu} trigger={["click"]}>
                                <span>
                                  <CameraOutlined /> Download
                                </span>
                              </Dropdown>
                            </Button>
                            <Divider type="vertical" />
                          </>
                        }

                      </>
                    )}
                  </div>
                  <FaExpandArrowsAlt
                    className={"full-screen-icon"}
                    onClick={fullScreenHandle.enter}
                  />
                </div>
                <Divider style={{ margin: "10px 0" }} />
                {hasDraftData ? (
                  <div className={"preview-footer"}>
                    <Alert
                      message="This is a test preview with placeholder data—save to display live data ->"
                      type="info"
                    />
                  </div>
                ) : null}

                <div
                  className={
                    previewReady ? "preview-ready" : "preview-not-ready"
                  }
                >
                  <TemplatePreview
                    key={
                      previewFormat +
                      animation.toString() +
                      mode +
                      currentTemplateData.updatedAt
                    }
                    previewFormat={previewFormat}
                    templateData={currentTemplateData}
                    animation={animation}
                    mode={animation ? "animation" : "screenshot"}
                    previewSrc={previewSrc}
                    isNew={isNew}
                    isFcb={isFcb}
                  />

                </div>
              </FullScreen>
            </div>
            {(isNew || !isFcb) && (
              <div className={"form-side"}>
                <TemplateEditForm
                  form={form}
                  newStylingData={newStylingData}
                  isFcb={isFcb}
                  setCurrentTemplateData={setCurrentTemplateData}
                  templateData={currentTemplateData}
                  setEditFormResponseData={setEditFormResponseData}
                  setVisible={setVisible}
                  selectedMatchday={selectedMatchday}
                  previewFormat={previewFormat}
                  onFormFinished={onFormFinished}
                />
              </div>
            )}
          </div>
        </Modal>
        {showEditModal && (
          <ImageEditorModal
            open={showEditModal}
            template={currentTemplateData}
            previewFormat={previewFormat}
            onClose={() => {
              setShowEditModal(false);
              setVisible(false);
            }}
          />
        )}
      </>
    )
  );
};

export default TemplateEditPopup;
